export const experienceList = [
  { value: "0 - 1 Year", label: "0 - 1 Year" },
  { value: "1 - 2 Years", label: "1 - 2 Years" },
  { value: "3+ Years", label: "3+ Years" },
];
